/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/assets/models/thug/thug.gltf --transform 
Files: public/assets/models/thug/thug.gltf [599.41KB] > F:\GitHub\Trap-Tycoon\frontend\thug-transformed.glb [731.82KB] (-22%)
Author: wolvee8 (https://sketchfab.com/wolvee8)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/thug-band-ms-13-lowpoly-5ec906d241f64ec592a84412b0e6feea
Title: Thug band (MS-13) lowpoly
*/

import React, { useEffect } from 'react' // Added useEffect
import { useGraph } from '@react-three/fiber'
import { useGLTF, useAnimations } from '@react-three/drei'
import { SkeletonUtils } from 'three-stdlib'

export function Thug({ animation = 'idle', ...props }) { // Added animation prop
  const group = React.useRef()
  
  const { scene, animations } = useGLTF('/assets/models/thug/thug-transformed.glb')
  
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene])
  const { nodes, materials } = useGraph(clone)
  
  // Extract animation actions
  const { actions, names } = useAnimations(animations, group)

  console.log("Available Animations:", names);

  useEffect(() => {
    // Play the requested animation and fade it in
    if (actions[animation]) {
      actions[animation].reset().fadeIn(0.5).play();
      return () => actions[animation].fadeOut(0.5);
    }
  }, [actions, animation]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <primitive object={nodes._rootJoint} />
        <skinnedMesh 
          name="Object_575" 
          geometry={nodes.Object_575.geometry} 
          material={materials['Retopo.010']} 
          skeleton={nodes.Object_575.skeleton} 
          rotation={[-Math.PI / 2, 0, 0]} 
          castShadow // Added shadow support
        />
      </group>
    </group>
  )
}

useGLTF.preload('/assets/models/thug/thug-transformed.glb')
